
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Dan ġie mill-proġett
                    <a href="${0}">Folksonomy Engine</a>. Toqgħodx
                    lura milli tipparteċipa jew tagħti feedback.`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Din l-għodda tippermettilek tikkoreġi l-lista tal-ingredjenti. Tista' żżid, tneħħi jew teditja
                il-lista tal-ingredjenti.
                <br>
                Dan il-karattru <span class="highlight">␣</span> jirrappreżenta spazju.
                <br>
                Dan il-karattru <span class="highlight">↩︎</span> jirrappreżenta qsim tal-linja. `,
'hb28f1f2ec1744ee9': html`Dawn il-proprjetajiet huma maħluqa u ffajljati mill-utenti għal kwalunkwe tip ta' użu. Ħossok
                    liberu li żżid tiegħek. Il-proprjetajiet u l-valuri li toħloq
                    <strong>iridu jkunu fattwali</strong>. Tista' tidħol fil-
                    <a href="${0}">lista ta' proprjetajiet li diġà jintużaw mill-komunità</a>
                    jew tesplora d-dokumentazzjoni tal-proprjetajiet
                    <a href="${1}">u l-magna tat-tiftix tagħha</a>.`,
's000a5b76bd3a01c2': `Qed jitgħabbew il-proprjetajiet...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Għinna għall-ingredjenti`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Ivvalida l-għelejjel`,
's03e9c8114521b998': `Se neditja l-ingredjenti`,
's05ec315d9308091a': `Ikona tal-kantunieri tal-barcode`,
's061eb5af92512c85': `Salvat! Tista' tgħin b'ieħor?`,
's06847c221c4c0bc1': `Nixtieq noħloq proprjetà biex [tiddeskrivi l-każ ta' użu tiegħek]...`,
's06f6c6f99db6b552': `Oriġinali`,
's081e2ad82db71e1d': `Valuri Miġbura`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `dokumentazzjoni ddedikata`,
's0bb2d48532acc455': `Niżżel is-CSV`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `Invalida l-immaġni`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Ikkanċella l-ħsad`,
's11a18a69b30b65ed': `Għinna nirranġaw żbalji fil-lista tal-ingredjenti`,
's1205d5f6fccf8e69': `Valur tal-Proprjetà`,
's15d64a0a6715285a': `Ċavetta ġdida`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Żona tal-għażla`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Għinna nikkoreġu l-informazzjoni nutrizzjonali`,
's1e00019dc454872d': `Jekk jogħġbok ipprovdi isem ta' proprjetà billi tuża l-attribut property-name.`,
's1e49126af0935a5b': `Lista ta' prodotti li jużaw din il-proprjetà`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `Iddokumenta l-proprjetà`,
's300b3a6ee4e1252d': str`Taqbila Fqira ${0}%`,
's33f786bb6b4f0cf4': `Riżultat tal-Uċuħ tar-Raba'`,
's33f85f24c0f5f008': `Save`,
's34be4af4e8fec4ae': `Staqsi lill-komunità l-ewwel`,
's36d86adc823cbfa6': `Qabel ma toħloq proprjetà ġdida, iddiskutiha mal-komunità:`,
's3781d25aa51a736c': `Dokumentazzjoni tal-Magna tal-Folksonomija`,
's383ae4449428b61e': `Irrisettja l-uċuħ tar-raba'`,
's39bcf88721a1e8ee': `Irrisettja l-għażla`,
's39e14e14300694c7': `Dokumentazzjoni u Linji Gwida`,
's3b430cfa5c1fe7f4': str`Dokumentazzjoni għal ${0}`,
's3f4e4b52f230a892': `Kanvas tal-immaġni`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Immaġni taċ-ċentru`,
's42dd66b2441566fd': `Ikona taċ-ċentru`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `Ibdel id-daqs lejn il-lemin`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Għadd ta' Prodotti`,
's4df2f533c0c1e7d0': `Kontrolli tal-immaġni`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Mexxi l-għażla`,
's4f751fb9b3ed766c': `Ħolqien ta' Proprjetà Ġdida`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Daħħal l-isem tal-proprjetà...`,
's55d7249883a98ca1': `dwar din il-proprjetà fuq Open Food Facts wiki`,
's565867d84c04aea2': `Proprjetajiet tal-filtru...`,
's5666afe5cd0166de': `Jekk jogħġbok irranġa l-iżbalji jew immodifika t-test qabel ma tikkonferma`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Qed jitgħabbew il-prodotti...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Għinna nikkoreġu l-informazzjoni nutrizzjonali.`,
's5dd6f12783fca34f': `Editja l-lista tal-ingredjenti`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Immaġni Maqtugħa`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Taqbila Tajba ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Dokumentazzjoni`,
's787dd11bed0dc88a': `Ibdel id-daqs lejn ix-xellug`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `Tgħallem aktar dwar il-ħolqien ta' proprjetà u l-linji gwida:`,
's8038273de2cf8b73': `Jekk jogħġbok agħżel reġjun biex taqta'.`,
's839cc2908a5387f2': `Iffiltra l-barcodes...`,
's86197dcf3e96af64': `Fittex u fittex proprjetajiet eżistenti`,
's8a63be30a129a59c': `Ibdel id-daqs tal-qiegħ`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Ibdel id-daqs fuq il-lemin`,
's8db84aa4bc949af2': `Iddokumenta l-Proprjetà l-Ġdida`,
's8f839a03997a16d7': `Ara l-Prodott`,
's901ae1e236ac45d3': `Ikkanċella t-tħassir`,
's907f7a97c6b29425': `Kun konxju li l-mudell tad-dejta jista' jiġi modifikat. Uża għar-riskju tiegħek.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Ingredjenti:`,
's9a7f60fce090ecaf': `Ma rnexxilniex nitgħabbew il-proprjetajiet. Jekk jogħġbok erġa' pprova aktar tard.`,
's9b87abd68fb9df45': `Ma sibtx? Oħloq ċavetta ġdida {value}`,
's9c0f52425fd2f07e': `Jista' ma jaqbilx`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `L-ebda Punteġġ Disponibbli`,
'sa548778b24054030': `Esplora l-proprjetajiet kollha kkontribwiti mill-proġett Folksonomy Engine. Dawn il-proprjetajiet jipprovdu metadata addizzjonali u tagħrif dwar il-prodotti fid-database Open Food Facts.`,
'sa63907958bd0ec4b': `Ibdel id-daqs fuq ix-xellug ta' fuq`,
'sa95b4224f685a36a': `Agħlaq il-modal`,
'sab56a1d439576fd6': `Ikona tas-suġġeriment`,
'sac47ea2901d04c15': `Ibdel id-daqs fin-naħa ta' isfel tax-xellug`,
'sb125227d436c2925': `Fittex il-kunċett tal-proprjetà tiegħek fid-database tal-proprjetajiet eżistenti:`,
'sb125568d43642e6f': `Wieġeb mistoqsijiet dwar il-prodott.`,
'sb1c538e038f9b214': str`Taqbila Tajba Ħafna ${0}%`,
'sb28639570ff3b852': `lista tal-proprjetajiet kollha`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Ladarba tkun ivverifikajt li l-proprjetà tiegħek ma teżistix u l-komunità taqbel li hija utli, l-ewwel trid tiddokumentaha fil-wiki.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Ma nstab l-ebda prodott għal din il-proprjetà.`,
'sb7f72e4c8a2d3357': `Iffiltra l-valuri...`,
'sb8178320160f84ea': `Uri l-ħsad`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `L-għarfien kollu ġie mwieġeb! Grazzi tal-għajnuna tiegħek!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `Valur Korrispondenti`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Ibdel id-daqs ta' fuq`,
'sc1c08d0cbcc3bd24': `Ma Jaqbilx`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Soluzzjoni ssuġġerita`,
'sc681b137e8f604f7': `Ikkonferma t-tħassir`,
'sc6daf8a31883f8b9': `Mexxi l-immaġni`,
'sc895972c88d38ca5': `Proprjetà ta' folksonomija`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Ringieli`,
'scb3b0671d7b7f640': `Valur ġdid`,
'scb489a1a173ac3f0': `Yes`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Ingħaqad mad-Diskussjoni ta' Slack`,
'scdb6cad0b92721bf': `Ma nstabet l-ebda proprjetà.`,
'scf23a05631f93732': `Ikkonferma t-Tħassir`,
'scfed2f270ef6a3aa': `Agħżel żona`,
'sd1022bc1ef9204f7': `Immaġni li tista' tiġi żżumjata`,
'sd1077c055cf9ba6b': `Għinna nivvalidaw il-lista tal-ingredjenti tal-prodott.`,
'sd698d21ddecba56b': `Ħej! Tista' tgħinna ntejbu l-informazzjoni dwar il-prodott billi twieġeb il-partijiet li ġejjin:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Iċċekkja jekk proprjetà diġà teżistix`,
'sdbf806fefc584115': `Għandek issib`,
'sdc673e73b5c13aea': `Delete`,
'sdc792b75f1edcaba': `Għinna nikkoreġu l-ortografija tal-ingredjenti.`,
'sdca5deead576ceee': `Ibdel id-daqs fil-qiegħ tal-lemin`,
'sdcc2555c5dde524f': `Żgur li trid tħassar dan l-oġġett? Din l-azzjoni ma tistax titneħħa.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Invalida`,
'se5127cf0f92e7e48': `Tip: tista' ssib ukoll`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Se nipproponi ħsad aħjar`,
'seea3800e27baa686': `Prodotti Individwali`,
'sefaba4adc4ec9219': `Proprjetajiet tal-Folksonomija`,
'seffa8ca49175b5f0': `Proprjetajiet personalizzati`,
'sf44a6b3b232c28ea': str`Ibdel il-valur attwali b' ${0}`,
'sf4cd86a2f5ef2588': `Kodiċi tal-Bar tal-Prodott`,
'sf57a61152168cc81': `Għinna nikkoreġu l-iskoperta tal-ingredjenti`,
'sf88b90b8ba23871c': `Taqbila Mhux Magħrufa`,
'sf9aee319a006c9b4': `Add`,
'sfacbbe968fa7d773': `Isem il-proprjetà:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Valur korrispondenti`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  